import { h } from 'preact'
import RetirementForm from './components/forms/retirement/retirementForm'
import RespForm from './components/forms/resp/respForm'
import WithdrawalForm from './components/forms/withdrawal/WithdrawalForm'
import InsuranceNeedsForm from './components/forms/insuranceNeeds/insuranceNeedsForm'
import InsuranceProceedsForm from './components/forms/insuranceProceeds/insuranceProceeds'
import NetWorthCalculator from './components/forms/netWorth/netWorthCalculator'
import CashFlowCalculator from './components/forms/cashFlow/cashFlowForm'

export default function App({ formName }) {
  function renderView() {
    switch (formName) {
      case 'retirement':
        return <RetirementForm formName={formName} />
      case 'withdrawal':
        return <WithdrawalForm formName={formName} />
      case 'resp':
        return <RespForm formName={formName} />
      case 'insurance-needs':
        return <InsuranceNeedsForm formName={formName} />
      case 'insurance-proceeds':
        return <InsuranceProceedsForm formName={formName} />
      case 'net-worth':
        return <NetWorthCalculator formName={formName} />
      case 'cash-flow':
        return <CashFlowCalculator formName={formName} />
      default:
        return <p>Error: Form not found.</p>
    }
  }

  return renderView()
}
